/*
 * @providesModule BracketMetaAPI
 */

import NetClient from 'NetClient';
import {NativeModules} from 'react-native';

const SKZAPIManager = NativeModules.SKZAPIManager;

// Type definitions for bracket meta API response
export interface Prize {
  cashPrize: number;
  roundNumber: number;
  ticketzPrize: number;
  is_winner: boolean;
  description: string;
}

export interface CurrentPlayerInfo {
  state:
    | 'REGISTER_PAYMENT_PENDING'
    | 'REGISTERED'
    | 'READY_TO_JOIN'
    | 'JOINED'
    | 'FINISHED'
    | 'WAITING_ROUND_END'
    | 'REGISTER_FAILED'
    | 'FINISHED_CANCELED'
    | 'ABORTED_GAMEPLAY'
    | 'ABORTED_TIMEOUT'
    | 'ABORTED_NOT_JOINED';
}

export interface BracketMeta {
  bracket_duration_in_secs: number;
  bracket_end_time: string;
  bracket_id: number;
  bracket_start_time: string;
  current_round: number;
  current_round_end_time: string;
  current_round_start_time: string;
  entry_fee: number;
  game_id: number;
  name: string;
  num_entries: number;
  players_per_tournament: number;
  prizes: Prize[];
  register_end_time: string;
  register_start_time: string;
  round_length_in_secs: number;
  rules_description: string;
  show_start_time: string;
  size: number;
  state: string;
  to_notify_register_start: boolean;
  total_rounds: number;
  total_ticketz: number;
  total_winners: number;
  total_winnings: number;
  tournament_template_id: number;
  tournaments_in_round: number;
  winner_cash_prize: number;
  finalist_cash_prize: number;
  winner_ticketz_prize: number;
  finalist_ticketz_prize: number;
}

export interface Pagination {
  page_number: number;
  total_pages: number;
  total: number;
  page_size: number;
}

export interface BracketMetaResponse {
  data: {
    bracket_meta: BracketMeta;
    matches: any[] | null;
    current_player_info?: CurrentPlayerInfo;
    pagination: Pagination;
  };
}

export interface BracketMetaParams {
  bracketId: string;
  page?: number;
  round?: number;
}

/**
 * Fetch bracket meta information
 */
export const fetchBracketMeta = (
  bracketId: string,
  page: number = 1,
  round?: number
): Promise<BracketMetaResponse> => {
  let url = `/v2/live-brackets/${bracketId}/info?page=${page}`;
  if (Number(round) > 0) {
    url += `&round=${round}`;
  }

  const retryMode = SKZAPIManager.OnError.failSilently;

  return new Promise((resolve, reject) => {
    NetClient.getURL(url, {}, retryMode)
      ?.then((payload: any) => {
        console.debug(`successful bracket meta fetch: GET ${url} ${JSON.stringify(payload)}`);
        resolve(payload as BracketMetaResponse);
      })
      .catch((error: Object) => {
        console.warn(`error on bracket meta fetch: GET ${url} ${JSON.stringify(error)}`);
        reject(error);
      });
  });
};
